export const colors = {
  primary: '#0137F3',
  white: '#fff',
  dark: '#000',
  opacityDark: '#00000033',
  grey: ['#f2f2f2', '#E0E0E0', '#D5D8E2', '#E9EBF2', '#E5E5E5', '#999999'],
};
